<script lang="ts">
import Vue from 'vue';

import VideoJumbotron from './sections/VideoJumbotron.ts.vue';
import JoinWhy from './sections/JoinWhy.ts.vue';
import JoinBenefits from './sections/JoinBenefits.ts.vue';
import JoinPartners from './sections/JoinPartners.ts.vue';
import Community from './sections/Community.ts.vue';
import Footer from './sections/Footer.ts.vue';

const sections = [
  VideoJumbotron,
  JoinWhy,
  JoinBenefits,
  JoinPartners,
  Community,
  Footer,
];

export default Vue.extend({
  render(h) {
    const children = sections.map(section => h(section));
    return h('article', {}, children);
  },
});
</script>
